import {useState} from "react";
import {useDispatch} from "react-redux";
import {reportError} from "../../../../redux/slice/errorReportSlice";
import ErrorReport from "../../../logic/error/ErrorReport";
import runAuthRequest from "../../../../redux/util/runAuthRequest";
import useSession from "../session/useSession";
import {logOut} from "../../../../redux/slice/authSlice";

const useAuthRequest = () => {

    const dispatch = useDispatch();
    const [ requestStatus, setRequestStatus ] = useState({});
    const session = useSession();
    const {
        loading,
        error,
        result
    } = requestStatus;

    const displayErrorReport = (error) => {
        const errorMsg = ErrorReport.getUserMessage(error);
        dispatch(reportError({ code: "authError", error: errorMsg }));
    }

    const logOutOnFailedAuth = () => {
        dispatch(logOut())
        dispatch(reportError({ code: "failedAuth", error: "You have been logged out" }));
    }

    const beforeRequest = () => {
        setRequestStatus({
            loading: true,
            error: null,
            result: null,
            pendingRefresh: null,
        })
    }

    const afterFailure = (error) => {
        setRequestStatus({
            loading: false,
            error,
            result: null,
            pendingRefresh: null,
        });
        if(error?.status === 401) {
            logOutOnFailedAuth();
        } else {
            displayErrorReport(error);
        }
    }

    const afterSuccess = (result, optionalTask) => {
        setRequestStatus({
            loading: false,
            error: false,
            result,
            pendingRefresh: null,
        });

        if(optionalTask)
            optionalTask(result);
    }

    const sendRequest = async (request, optionalTask) => {
        try {
            const result = await runAuthRequest(session?.sessionData, s => request(s), dispatch);
            afterSuccess(result, optionalTask);
        } catch (error) {
            afterFailure(error);
        }
    }

    const sendIt = (request, optionalTask) => {
        beforeRequest();
        void sendRequest(request, optionalTask);
    }

    return {
        session,
        loading,
        error,
        result,
        sendIt
    }

}

export default useAuthRequest;
